import React, { Fragment } from "react";
import { Link, NavLink } from "react-router-dom";

import { SITENAMEALIAS, SITENAME, LOGO, CAPTCHASITEKEY } from "../utils/init";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const brokerName =
      localStorage.getItem(SITENAMEALIAS + "_exchange") || "PayBito";

    return (
      <Fragment>
        <footer
          className="footer"
          style={{
            background: "var(--body-color)",
            position: "fixed",
            bottom: 0,
            width: "100%",
          }}
        >
          <div className="d-sm-flex justify-content-center justify-content-sm-between"></div>

          <div>
            <span className="d-block text-center text-sm-left d-sm-inline-block text-muted">
              © {new Date().getFullYear()} {brokerName}. All Rights Reserved.
            </span>
          </div>
        </footer>
      </Fragment>
    );
  }
}

export default Footer;
